import axios from 'axios';
import Cookies from 'js-cookie';

export const getCurrentUser = async () => {
  const response = await axios.get("/club_api/users/profile");
  return response.data;
};


export const login = async (params) => {
  const response = await axios.post("/club_api/sessions", { session: {...params }});

  setToken(response.data?.session?.token);

  return response.data.user;
};

export const logout = async () => {
  const response = await axios.delete("/club_api/sessions/logout");

  Cookies.remove('_admin_session');

  return response.data;
};

export const forgotPassword = async ({ email }) => {
  const response = await axios.post("/club_api/sessions/forgot_password", { email });

  return response.data;
};

const setToken = token => {
  Cookies.set('_admin_session', token);
  axios.defaults.headers.common.Authorization = `${token}`;
};



